import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './services/api.service';
import { CommonService } from './services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'vigi-ui';

  constructor(private router: Router, private apiService: ApiService, commonService: CommonService){
  }

  ngOnInit() {
    this.initializeSession();
  }

  initializeSession() {
    let sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) {
      sessionId = this.generateRandomString(16);
      sessionStorage.setItem('sessionId', sessionId);
    }
  }

  generateRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}
